import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Controller, useFormContext } from 'react-hook-form';
import { useEditInputStyles } from './styles';
import useMyPage from '@hooks/useMyPage';
import { Grid, TextField } from '@material-ui/core';
import useClient from '@hooks/useClient';

interface Props {
  onSubmit: (_: any) => void;
  onCancel: () => void;
}

export const FieldEditInputPresenter = ({ onSubmit, onCancel }: Props) => {
  const classes = useEditInputStyles();
  const { control } = useFormContext();
  const { profile } = useMyPage();
  const { clientState } = useClient();
  const editTitle = profile.label ?? '';
  const fieldName = profile.field[0].fieldName ?? '';
  const name =
    fieldName === 'cellphoneNumber' ? 'cellphoneNumber' : 'managerName';
  const placeholder = profile.placeholder ?? [];

  return (
    <>
      <CustomizedTypography
        color="textSecondary"
        variant="body1"
        gutterBottoms={12}
      >
        {editTitle}
      </CustomizedTypography>
      <Controller
        name={name}
        defaultValue={
          fieldName === 'cellphoneNumber'
            ? clientState.cellphoneNumber
            : clientState.managerName
        }
        control={control}
        rules={
          fieldName === 'cellphoneNumber'
            ? {
                maxLength: {
                  value: 11,
                  message: '휴대폰 번호는 11자리 숫자로 입력해주세요.'
                },
                minLength: {
                  value: 11,
                  message: '휴대폰 번호는 11자리 숫자로 입력해주세요.'
                },
                required: {
                  value: true,
                  message: '휴대전화번호를 입력해주세요.'
                }
              }
            : fieldName === 'managerName'
            ? {
                pattern: {
                  value: /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]+$/,
                  message: '특수문자 없이 20자 이내로 입력하셔야 합니다.'
                },
                maxLength: {
                  value: 20,
                  message: '특수문자 없이 20자 이내로 입력하셔야 합니다.'
                },
                minLength: {
                  value: 1,
                  message: '특수문자 없이 20자 이내로 입력하셔야 합니다.'
                },
                required: {
                  value: true,
                  message: '특수문자 없이 20자 이내로 입력해주세요.'
                }
              }
            : {}
        }
        render={(renderProps) => {
          return (
            <TextField
              {...renderProps}
              classes={{ root: classes.textfieldRoot }}
              InputProps={{
                classes: {
                  root: classes.InputRoot,
                  input: classes.input
                }
              }}
              type={fieldName === 'cellphoneNumber' ? 'number' : 'text'}
              placeholder={placeholder[0]}
              variant="outlined"
              size="medium"
              fullWidth
            />
          );
        }}
      />
      <Grid container className={classes.buttonContainer}>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="outlined"
          color="primary"
          size="medium"
          onClick={onCancel}
        >
          취소하기
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
          onClick={onSubmit}
        >
          수정하기
        </CustomizedButton>
      </Grid>
    </>
  );
};

interface Props {
  onSubmit: (_: any) => void;
  onCancel: () => void;
}

export const DepartmentEditPresenter = ({ onSubmit, onCancel }: Props) => {
  const classes = useEditInputStyles();
  const { control } = useFormContext();
  const { clientState } = useClient();

  return (
    <>
      <CustomizedTypography
        color="textSecondary"
        variant="body1"
        gutterBottoms={12}
      >
        부서
      </CustomizedTypography>
      <Controller
        name={'department'}
        defaultValue={clientState.department}
        control={control}
        render={(renderProps) => {
          return (
            <TextField
              {...renderProps}
              classes={{ root: classes.textfieldRoot }}
              InputProps={{
                classes: {
                  root: classes.InputRoot,
                  input: classes.input
                }
              }}
              placeholder={'부서를 입력해주세요.'}
              variant="outlined"
              size="medium"
              fullWidth
            />
          );
        }}
      />
      <CustomizedTypography
        color="textSecondary"
        variant="body1"
        gutterBottoms={12}
      >
        직함
      </CustomizedTypography>
      <Controller
        name={'position'}
        defaultValue={clientState.position}
        control={control}
        render={(renderProps) => {
          return (
            <TextField
              {...renderProps}
              classes={{ root: classes.textfieldRoot }}
              InputProps={{
                classes: {
                  root: classes.InputRoot,
                  input: classes.input
                }
              }}
              placeholder={'직함을 입력해주세요.'}
              variant="outlined"
              size="medium"
              fullWidth
            />
          );
        }}
      />
      <Grid container className={classes.buttonContainer}>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="outlined"
          color="primary"
          size="medium"
          onClick={onCancel}
        >
          취소하기
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
          onClick={onSubmit}
        >
          수정하기
        </CustomizedButton>
      </Grid>
    </>
  );
};
